import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, Tooltip, Typography, Link, IconButton, Menu } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import MediaItemsSearch from './MediaItemsSearch';
import FilterListIcon from '@mui/icons-material/FilterList';

const styles = theme => ({
    stockVideosLabel: {
        marginRight: theme.spacing(1)
    },
    orientationSettings: {
        marginRight: '5px'
    }
});

const StockVideosSearch = (props) => {
    const { classes, searchValue, isSearching, contextMenuAnchor, setContextMenuAnchor, onSearchValueChange, clearResults, onSearchValueSubmit, disableClearButton, stockMediaOrientationSelect } = props;

    return (
        <>
            {!disableClearButton &&
                <Grid>
                    <Typography
                        className={classes.stockVideosLabel}
                        variant='subtitle2'
                        color='textSecondary'
                    >
                        Videos by&nbsp;
                        <Link
                            href='https://www.pexels.com'
                            target='_blank'
                            color='textSecondary'
                            underline='always'
                        >
                            Pexels
                        </Link>
                    </Typography>
                </Grid>
            }
            <Grid>
            <Tooltip
                title={"Orientation Filter"}
                placement={'top'}
                arrow
            >
                <IconButton
                    className={classes.orientationSettings}
                    onClick={(event) => setContextMenuAnchor(event.currentTarget)}
                    aria-label='Orientation Settings'
                    aria-controls='orientation-settings-menu'
                    aria-haspopup='true'
                    size="large"
                >
                    <FilterListIcon />
                </IconButton>
                </Tooltip>
            </Grid>
            <Grid>
                <Tooltip
                    title={"Clear Results"}
                    placement={'top'}
                    arrow
                >
                    <span>
                        <IconButton
                            className={classes.orientationSettings}
                            onClick={clearResults}
                            disabled={disableClearButton}
                            aria-label='Orientation Settings'
                            aria-controls='orientation-settings-menu'
                            aria-haspopup='true'
                            size="large">
                            <CloseIcon />
                        </IconButton>
                    </span>
                </Tooltip>
            </Grid>
            <Grid>
                <MediaItemsSearch
                    value={searchValue}
                    placeholder="Search Videos"
                    onValueChange={onSearchValueChange}
                    onValueSubmit={onSearchValueSubmit}
                    isSearching={isSearching}
                />
            </Grid>
            <Menu
                id='orientation-settings-menu'
                anchorEl={contextMenuAnchor}
                keepMounted
                open={Boolean(contextMenuAnchor)}
                onClose={() => setContextMenuAnchor(undefined)}
            >
                {stockMediaOrientationSelect}
            </Menu>
        </>
    );
};

export default withStyles(StockVideosSearch, styles);